// Shared image-URL helper. Ported from the app's toGeneratedImageUrl().
// Relative names resolve against the generated-images CDN; absolute URLs are
// passed through (decoding a proxy `url=` param if present).

export const GENERATED_IMAGES_BASE = 'https://travelens.in/app/generated_images/';

// decodeURIComponent that never throws on malformed input.
function safeDecodeUrl(s) {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}

// If the URL is an image proxy wrapping the real target in a `url` query param
// (e.g. https://img-proxy/?url=https%3A%2F%2F…), unwrap and decode it.
function decodeProxyParam(url) {
  try {
    const u = new URL(url);
    const inner = u.searchParams.get('url');
    if (inner) return safeDecodeUrl(inner);
  } catch {
    /* not a parseable URL — fall through */
  }
  return url;
}

/**
 * Build a usable image URL from a stored value.
 * @param {string} [img] relative name or absolute URL
 * @returns {string|null}
 */
export function toGeneratedImageUrl(img) {
  if (!img) return null;
  const decoded = safeDecodeUrl(img);
  return decoded.startsWith('http')
    ? decodeProxyParam(decoded.trim().replace(/\u00A0/g, ''))
    : `${GENERATED_IMAGES_BASE}${decoded}`;
}
